module.exports = __webpack_public_path__ + "static/img/footer-bg.0968dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/footer-bg.png
// module id = Zid0
// module chunks = 1